import { isChildNode } from 'module/helpers/is-child-node';
import { dialogAwarePopupContainer } from 'module/hooks/use-dialog-hosted-overlays';
import { EstimateField } from 'module/types/filter-field/field/filterable-field';
import { DateFieldFilter } from 'module/types/filter-field/filter/date';
import { EstimateFieldFilter } from 'module/types/filter-field/filter/estimate';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { Dropdown } from 'antd';
import { FC, useCallback, useEffect, useState } from 'react';
import { Trigger } from './components';
import { format } from './format';
import { renderOverlay } from './overlay';

interface Props {
  filter: EstimateFieldFilter;
  onChange: (filter: EstimateFieldFilter) => void;
  getFilterOperationTypeOptions?: (field: EstimateField) => DateFieldFilter[];
}

export const EstimateCriteria: FC<React.PropsWithChildren<Props>> = ({
  filter,
  onChange,
}) => {
  const [visible, setVisible] = useState(false);
  const isChild = isChildNode([
    'date-criteria',
    'ant-dropdown',
    'ant-picker-dropdown',
  ]);
  const close = useCallback(
    (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;

      if (target != null && !isChild(target)) {
        setVisible(false);
      }
    },
    [setVisible, isChild],
  );

  useEffect(() => {
    if (!visible) {
      return () => {};
    }
    document.addEventListener('click', close);

    return () => {
      document.removeEventListener('click', close);
    };
  }, [close, visible]);

  return (
    <Dropdown
      trigger={['click']}
      visible={visible}
      getPopupContainer={dialogAwarePopupContainer}
      overlay={renderOverlay(filter, onChange)}
    >
      <Trigger className="date-criteria" onClick={() => setVisible(!visible)}>
        <span>{format(filter)}</span>
        <FontAwesomeIcon icon={faChevronDown} />
      </Trigger>
    </Dropdown>
  );
};
